/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Report_Material_AddInputs */



/**
* | output |
* | --- |
* | "Paste your notes from OneNote, Word or another document here…" |
*
* @param {Meeting_Report_Material_AddInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_report_material_add = /** @type {((inputs?: Meeting_Report_Material_AddInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Report_Material_AddInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Plak hier je notities uit OneNote, Word of een ander document…")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Collez ici vos notes depuis OneNote, Word ou un autre document…")
	return /** @type {LocalizedString} */ ("Paste your notes from OneNote, Word or another document here…")
});